import { useSyncExternalStore } from 'react'
import { useTranslation } from 'react-i18next'
import { cx } from '../lib/cx'
import { Icon, type IconName } from './Icon'
import { toast, type ToastTone } from './toastStore'
import './Toast.css'

const TONE_ICON: Record<ToastTone, IconName> = {
  info: 'info',
  success: 'check_circle',
  error: 'error',
}

/**
 * Where toasts appear: one polite live region, rendered once by the app shell. The
 * region is always present so screen readers announce what is added to it. Toasts
 * fade and rise 8 dp over 150 ms (motion-fast); with reduced motion they only fade.
 */
export function ToastViewport() {
  const { t } = useTranslation()
  const current = useSyncExternalStore(toast.subscribe, toast.getItems, toast.getItems)
  return (
    <div className="toast-viewport" role="status" aria-live="polite" aria-relevant="additions text">
      {current.map((item) => (
        <div key={item.id} className={cx('toast', `toast--${item.tone}`, item.leaving && 'toast--leaving')}>
          <Icon name={TONE_ICON[item.tone]} className="toast__icon" />
          <p className="toast__message">{item.message}</p>
          {item.action && (
            <button
              type="button"
              className="toast__action"
              onClick={() => {
                item.action?.onAction()
                toast.dismiss(item.id)
              }}
            >
              {item.action.label}
            </button>
          )}
          <button type="button" className="toast__close" onClick={() => toast.dismiss(item.id)}>
            <Icon name="close" label={t('kit.toast.dismiss')} size={20} />
          </button>
        </div>
      ))}
    </div>
  )
}
